<template>
  <section class="points-exchange-mapipay mt-4">
    <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>
    <app-page-header title="Resgate seus pontos"></app-page-header>

    <div class="container info-box">
      <div class="info-important">
        <h2>ATENÇÃO !</h2>
        <h2>PARA REALIZAR O RESGATE SIGA OS PASSOS ABAIXO</h2>

        <ol class="list-notice">
          <li>Baixe o APP MapiPay através dos links <a href="">GooglePlay</a> ou <a href="">AppleStore</a> , em seguida se cadastre.</li>
          <li>Solicite o resgate dos pontos aqui mesmo pela plataforma Clube Venda e Ganhe</li>
        </ol>
        <br>
        <p>
          O prazo de conversão de pontos em saldo na sua conta <b>MapiPay</b> é de até 48h úteis após a realização dos 2 passos citados acima.
        </p>
        <p>
         Caso encontre problemas nesse processo, entre em contato com nosso atendimento pelo e-mail:
          <a href="mailto:atendimento@clubevendaeganhe.com.br"
            >atendimento@clubevendaeganhe.com.br</a
          >, telefone: (41) 3114-7282 ou WhatsApp: (41) 99267-8525.
        </p>
      </div>
    </div>
    <br><br>    
    <div v-if="!hasFinished" class="boxes-container">
      <div class="box">
        <h1>Quantos pontos deseja trocar?</h1>
        
        <div class="image">
          <img src="@/assets/img/mapipay2.png" alt="MapiPay" />
        </div>

        <b>Com MapiPay você pode:</b>
        <ol> 
          <li>Transferir para conta CC ou poupança</li>
          <li>Comprar pela internet com cartão virtual</li>
          <li>Transferir entre contas MapiPay</li>
          <li>Fazer pagamentos de boletos online</li>
          <li>Realizar recargas de celular</li>
        </ol>
        <app-input class="points-input" type="number" v-model="redeemPoints" />
        <button 
          @click="onSubmit()"
          :disabled="redeemPoints <= 0 || isLoading"
          type="button"
          class="app-button"
        >
          RESGATAR
        </button>
        <p>
          Ao clicar no botão de resgate acima, estou de acordo com o
          <a
            href="https://www.clubevendaeganhe.com.br/files/termos/termo_quitacao.pdf"
            >Termo de Adesão à Campanha e Uso do Conta MapiPay</a
          >
        </p>
      </div>
    </div>

    <div v-if="hasFinished" class="has-finished">
      <h1>Resgate realizado!</h1>
      <p>Acesse os sites para poder usufruir dos seus créditos!</p>

      <div>
        <a :href="philcoLink" target="_blank">
          <button type="button" v-app-button.secondary>
            Ir para Philco Club
          </button>
        </a>
      </div>

      <div>
        <a :href="britaniaLink" target="_blank">
          <button type="button" v-app-button>Ir para Britânia em Casa</button>
        </a>
      </div>

      <div>
        <router-link :to="{ name: 'site.index' }" class="home-link"
          >Voltar ao início</router-link
        >
      </div>
    </div>

    
    <div class="container boxs info-box">

      <h2>CADASTRO DA CONTA</h2>
      <p>
        Para resgatar seu saldo utilizando sua conta MapiPay, você deverá realizar o download pelo <a href="">Google Play</a> ou <a href="">Apple Store</a>.
      </p>
      <p>
        Após realizar o donwload selecione a opção <b>Abrir uma conta para você</b> e insira suas informações. É rapído e fácil!
      </p>
      <p>
        Caso tenha duvidas, veja o passo a passo para esse procedimento clicando <a href="">aqui</a>.
      </p>

      <h2>TAXAS TRANSFERÊNCIAS E MANUTENÇÃO</h2>
      <p>
        Taxa de transferência para conta: R$ 4,50.
        <br/>Taxa de manutenção da conta: R$ 4,90 mensal sobre o saldo da conta.
      </p>

      <h2>PRAZO DE TRANSFERÊNCIA DE PONTOS</h2>
      <p>
        O prazo de conversão de pontos em saldo na conta é de até 48h úteis. A
        conversão dos pontos em saldo na conta não é automática.
      </p>
      <p>
        <b>Obs:</b> ressaltamos que para o utilizar essa modalidade de resgate, o premiado dever ter a conta MapiPay baixada e cadastrada, sendo necessario realizar esse procedimento apenas na primeira vez.
      </p>

    </div>

  </section>
  
</template>



<script>
import RedemptionMapiPayService from '@/services/redemption-mapipay.service';
import ExchangeService from '@/services/exchange.service';
import ClientService from '@/services/client.service'; 
 
import { UPDATE_USER } from '@/store/actions/auth';
import { SUM_POINTS } from '@/store/actions/auth'; 

export default {
  name: 'points-exchange-mapipay',
  data: () => {
    return { 
      isLoading: false,
      isSubmitting: false,
      exchange: null,
      client: {
        points: null,
        address: {
          street: null,
          number: null,
          neighborhood: null,
          city_id: null,
          city: {
            name: null,
            state: {
              code: null,
            },
          },
        },
      },
      redeemPoints: null,
    };
  },
  computed: {
    points() {
      return this.$store.getters.userPoints;
    },
    conversion() {
      return this.exchange ? this.exchange.value * this.points : 0;
    },
  },
  methods: {
    load() {
      this.isLoading = true;

      Promise.all([ClientService.getSelf(), ExchangeService.get()])
        .then(([{ data: client }, { data: exchange }]) => {
          this.exchange = exchange;
          this.client = client;
          this.redeemPoints = client.points;
          this.$store.dispatch(UPDATE_USER, { points: client.points });
        })
        .finally(() => setTimeout(() => (this.isLoading = false), 200));
    },
    onSubmit() {
      if (this.isSubmitting) return;

      this.isSubmitting = true;
      this.isLoading = true;

      this.$buefy.dialog.confirm({
        message: 'Tem certeza que deseja realizar o resgate ?',
        cancelText: 'Cancelar',
        confirmText: 'Sim', 
        type: 'is-primary',
        onConfirm: () => this.submit(), 
        onCancel: () => {
          this.isSubmitting = false;
          this.isLoading = false;
        },
      });
    },
    submit() {
      const points = this.redeemPoints;

      this.process(points).finally(() => {
        this.isSubmitting = false;
        this.isLoading = false;
      });
    },
    process(points) {
      return RedemptionMapiPayService.trade(points)
        .then(() => { 
          this.$store.dispatch(SUM_POINTS, -points);
          this.toastify('Resgate concluído com sucesso!');
          this.$router.push('/');
        })
        .catch(({ response }) => {
          const { status, data } = response;

          if (status === 403 && data.activateCard) {
            this.showCardDialog(points);
          } else if (status === 429) {
            this.toastify(
              'Verificamos múltiplas tentativas consecutivas de resgate. Tente novamente mais tarde.',
              'error'
            );
          } else {
            this.toastify(data.message, 'error');
          }
        });
    },
    showCardDialog(points) {
      this.$buefy.dialog.prompt({
        title: 'Ativar cartão',
        message:
          'Verificamos que o seu cartão ainda não foi ativado. Insira abaixo os 4 últimos digitos dele para ativá-lo.',
        cancelText: 'Não recebi o cartão',
        confirmText: 'Ativar',
        inputAttrs: {
          placeholder: 'ex: 1234',
          minLength: 4,
          maxLength: 4,
        },
        onCancel: () => {
          this.isLoading = true;

          this.process(points, true)
            .then(() => {
              this.$buefy.dialog.alert({
                title: 'Resgate realizado',
                message:
                  'A carga só será efetivada após a ativação do seu cartão! Ative-o assim que recêbe-lo.',
              });
            })
            .finally(() => (this.isLoading = false));
        },
        onConfirm: (value) => this.activateCard(value),
      });
    },
  },
  mounted() {
    this.load();
  },
};
</script>


<style lang="scss" scoped>
section.points-exchange-mapipay {
  position: relative;

  .boxes-container {
    display: flex;
    justify-content: center;
    margin: 0 15vh;
  }

  .box {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 2em;
    border-radius: 8px;
    border: 1px solid var(--color-secondary);
    box-shadow: none;
    max-width: 390px;
    margin-bottom: 0;

    h1 {
      font-size: 2em;
      font-weight: bold;
      text-align: center;
      margin-bottom: 1em;
    }

    button {
      margin-bottom: 1.5em;
    }

    p {
      font-size: 1em;
      font-family: var(--font-family-secondary);
      text-align: center;
      color: var(--text-color-light);
    }
  }
}
ol{
  margin-left: 15px;
}
.boxs {
  background: var(--color-light-grey);
  border-radius: 12px;
  padding: 2em;

  font-size: 1.1em;

  strong {
    font-weight: bold;
    font-size: 1.2em;
    color: var(--text-color-medium);
    margin-bottom: 0.8em;
  }

  .address {
    display: flex;
    flex-direction: column;
  }

  .redeem-points {
    h2 {
      font-weight: bold;
      font-size: 1.2em;
      color: var(--text-color-medium);
    }

    .section {
      margin: 0;

      .points-container {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .points {
          font-size: 2em;
          font-weight: bold;
          color: var(--color-primary);
        }

        .conversion {
          font-size: 1em;
          color: var(--text-color-light);
        }
      }

      .message {
        color: var(--color-primary);
        background: var(--color-light-grey);
        font-weight: bold;
        font-size: 1.3em;
      }
    }

    hr {
      margin: 0;
      padding: 0;
      background: var(--text-color-light);
    }
  }
}


.has-finished {
  text-align: center;

  h1 {
    font-size: 2rem;
    font-family: var(--font-family-secondary);
    font-weight: bold;
    color: var(--color-primary);
  }

  p {
    font-size: 1.2rem;
    color: var(--text-color-light);
    margin-bottom: 32px;
  }

  > div {
    margin-bottom: 12px;
  }
}

@media (max-width: 992px) {
  section.points-exchange-page {
    padding: 0 1em;
    .boxes-container {
      margin: 0;
    }
  }
}

.image{
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.box {
  background: var(--color-light-grey);
  border-radius: 12px;
  padding: 2em;

  font-size: 1.1em;

  strong {
    font-weight: bold;
    font-size: 1.2em;
    color: var(--text-color-medium);
    margin-bottom: 0.8em;
  }

  .address {
    display: flex;
    flex-direction: column;
  }

  .redeem-points {
    h2 {
      font-weight: bold;
      font-size: 1.2em;
      color: var(--text-color-medium);
    }

    .section {
      margin: 0;

      .points-container {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .points {
          font-size: 2em;
          font-weight: bold;
          color: var(--color-primary);
        }

        .conversion {
          font-size: 1em;
          color: var(--text-color-light);
        }
      }

      .message {
        color: var(--color-primary);
        background: var(--color-light-grey);
        font-weight: bold;
        font-size: 1.3em;
      }
    }

    hr {
      margin: 0;
      padding: 0;
      background: var(--text-color-light);
    }
  }
}

h1 {
  font-size: 2em;
  font-weight: bold;
  text-align: center;
}

.redeem-container {
  .redeem-inputs {
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 15vw;
    margin: 2em auto;
  }

  p {
    text-align: center;
  }
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.list-notice{
  margin-left: 15px;
}

/* Firefox */
input[type='number'] {
  -moz-appearance: textfield;
}

.info-box {
  margin-top: 2em;
  h2 {
    font-weight: bold;

    &:not(:first-child) {
      margin-top: 2em;
    }
  }

  .info-important {
    background: gold; 
    padding: 1em;
    border-radius: 8px;
    color: black;

    a {
      color: #000;
      font-weight: bold;

      &:hover {
        color: #000;
        text-decoration: underline;
      }
    }
  }
}

@media (max-width: 992px) {
  section.points-exchange-mapipay {
    padding: 0 1em;

    .redeem-container {
      .redeem-inputs {
        max-width: 100%;
      }
    }
  }

  .info-box {
    padding: 1em;
  }
}
</style>
